import initialState from './initialState'
import {
    SHOPPING_LIST_INITIALIZE_LIST,
    SHOPPING_LIST_CREATE_LIST,
    SHOPPING_LIST_UPDATE_LIST,
    SHOPPING_LIST_CREATE_ITEM,
    SHOPPING_LIST_EDIT_ITEM,
    SHOPPING_LIST_DELETE_ITEM,
    SHOPPING_LIST_CLEAR_ITEMS
} from '../constants/actionTypes'


export default (state = initialState, action) => {
    switch (action.type) {
        case SHOPPING_LIST_INITIALIZE_LIST:
            return {
                ...state,
                ...action.data
            }

        case SHOPPING_LIST_CREATE_LIST:
            return {
                ...state,
                listId: action.listId,
                isChanged: false
            }

        case SHOPPING_LIST_UPDATE_LIST:
            return {
                ...state,
                ...action.data
            }

        case SHOPPING_LIST_CREATE_ITEM:
            return {
                ...state,
                ids: [action.id].concat(state.ids),
                byId: {
                    [action.id]: {
                        id: action.id,
                        ...action.data
                    },
                    ...state.byId
                },
                isChanged: true
            }

        case SHOPPING_LIST_EDIT_ITEM:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.id]: {
                        ...state.byId[action.id],
                        ...action.data
                    }
                },
                isChanged: true
            }

        case SHOPPING_LIST_DELETE_ITEM:
            return {
                ...state,
                ids: state.ids.filter(id => id !== action.id),
                byId: {
                    ...Object.keys(state.byId).reduce((items, itemId) => {
                        if (itemId !== action.id) {
                            items[itemId] = {
                                ...state.byId[itemId]
                            }
                        }

                        return items
                    }, {})
                },
                isChanged: true
            }

        case SHOPPING_LIST_CLEAR_ITEMS:
            return initialState

        default:
            return state
    }
}
